export default __webpack_public_path__ + "static/media/higher_primary_logo_centered_openbeta.a5aee6d3.svg";